import Entity from 'lib/Entity';
import apiRequest from 'lib/apiRequest';

import _ from 'lodash';

class Subscription extends Entity {
  initialize() {
    this.urlRoot = '/subscriptions';
  }

  parse(response: any) {
    const subscription = _.clone(response);
    subscription['subscribed_at'] = new Date(subscription['subscribed_at']);
    return subscription;
  }

  getSubscriberId() {
    return this.get('subscriber_id');
  }

  getGroupId(): number {
    return this.get('group').id;
  }

  getGroupCode(): string {
    return this.get('group').getCodeOrError();
  }

  getSubscribedAt(): Date {
    return this.get('subscribed_at');
  }

  static initiateDeviceSubscription(groupCode: string, recipient?: string) {
    return apiRequest(`/subscribe/${groupCode}`, 'POST', {
      recipient,
    });
  }
}

export default Subscription;
